<template>
    <div id="container"></div>
</template>

<script>
import { shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import { ref, reactive, toRefs, onMounted } from 'vue';
export default {
    name: "map-container",
    emits: ["initResult"],
    props: {
        mapStyle: {
            type: String,
            default: "amap://styles/normal"
        }
    },
    setup(props, context) {
        const aMap = shallowRef(null);
        const map = shallowRef(null);
        const loca = shallowRef(null);
        const autoComplete = shallowRef(null);

        const datas = reactive({

        })

        const methods = {
            initMap() {
                window._AMapSecurityConfig = {
                    securityJsCode: 'd218e73b159db295ac7eb105355efc83',
                }
                AMapLoader.load({
                    key: "43941e413cee2918d38fd7211c24929f", // 申请好的Web端开发者Key，首次调用 load 时必填
                    version: "2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                    plugins: [],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
                    Loca: {                // 是否加载 Loca， 缺省不加载
                        "version": '2.0.0'  // Loca 版本，缺省 1.3.2
                    }
                }).then((AMap) => {
                    aMap.value = AMap
                    map.value = new AMap.Map("container", {  //设置地图容器id
                        viewMode: "3D",    //是否为3D地图模式
                        pitch: 20, // 地图俯仰角度，有效范围 0 度- 83 度
                        mapStyle: props.mapStyle, // 地图样式
                        zoom: 11.5,
                        // rotation: 3,
                        center: [114.039575, 22.443561],
                        // showLabel: false,
                        showBuildingBlock: false,
                    });

                    AMap.plugin('AMap.AutoComplete', function () {
                        var autoOptions = {
                            //city 限定城市，默认全国
                            city: '全国'
                        };
                        // 实例化AutoComplete
                        autoComplete.value = new AMap.AutoComplete(autoOptions);
                    })

                    // 创建 Loca 实例
                    loca.value = new Loca.Container({
                        map: map.value
                    });

                    context.emit("initResult", aMap.value);

                }).catch(e => {
                    console.log(e);
                })
            },
            async initAutoComplete(value) {
                return new Promise((resolve, reject) => {
                    // 根据关键字进行搜索
                    autoComplete.value.search(value, function (status, result) {
                        // 搜索成功时，result即是对应的匹配数据
                        resolve(result);
                    })
                })
            },
            addMarker(addrList, isClearMap) {
                if (isClearMap) {
                    map.value.clearMap();
                }
                let makerList = [];
                addrList.forEach(element => {
                    const location = element.location;
                    if (location) {
                        const marker = new aMap.value.Marker({
                            position: new aMap.value.LngLat(location.lng, location.lat),
                            offset: new aMap.value.Pixel(-10, -10),
                            title: element.name,
                            label: element.label,
                            icon: element.icon
                        });
                        map.value.add(marker);
                        makerList.push(marker);
                    }
                });
                map.value.setFitView(makerList);
            }
        }

        onMounted(() => {
            methods.initMap();
        })


        return {
            map,
            ...methods,
            ...toRefs(datas)
        }
    },
}
</script>

<style scoped>
#container {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
}
</style>